/* Optibio Scroll Reveal. Lightweight IntersectionObserver for all pages.
   Reveals manual .optibio-reveal elements AND auto-reveals content sections
   site-wide so every page animates on scroll (not just ones with reveal classes). */
(function() {
  'use strict';

  var SELECTOR = '.optibio-reveal, .optibio-line-draw, .optibio-line-reveal';
  // Sections that already animate internally — never double-tag these.
  // (.ob-product-buybox self-reveals via its own snippet script.)
  var EXISTING = '.optibio-reveal,.cdr-reveal,.ob-reveal,.ob-product-buybox,.optibio-line-draw,.optibio-line-reveal';

  var REBUILT = '.bw-home-port,.bwp,.bwc,.bw-needs,.bw-quiz,.bwct,.bwa,.bwu,.bwf,.bwcart-page,.bwcart-drawer';
  function rebuilt(el) {
    return !!(el.closest(REBUILT) || (el.classList.contains('shopify-section') && el.querySelector(REBUILT)));
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Auto-tag main-content sections that don't already animate, so pages with no
  // manual reveal classes (science, about, FAQ, shop, articles, collections)
  // still get the scroll reveal. Fail-safe: this only runs in JS, so if JS never
  // runs nothing is ever hidden. Skips the hero (LCP) and chrome sections.
  function chrome(s) {
    var t = (s.id || '') + ' ' + (s.className || '');
    return /marquee|announce|header|footer|breadcrumb/i.test(t);
  }
  function heroish(s) {
    var t = (s.id || '') + ' ' + (s.className || '');
    return /hero/i.test(t);
  }
  function tagEl(el) {
    if (rebuilt(el)) return;
    if (!el.classList.contains('optibio-reveal') && !el.querySelector(EXISTING)) {
      el.classList.add('optibio-reveal');
    }
  }

  function autoTag() {
    if (reducedMotion()) return;
    var main = document.querySelector('#MainContent, main, [role="main"]') || document.body;
    // (The buy-box card self-reveals via its own snippet script, and any section
    //  containing it is skipped via EXISTING above — so no double reveal.)
    var sections = main.querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      if (chrome(sec) || rebuilt(sec)) continue;
      if (sec.querySelector(EXISTING)) continue;        // already animates internally
      // Redesign content pages are one big .shopify-section wrapping nested
      // <section> blocks (sn-sec, sp-sec, etc.) — reveal those individually so
      // monolithic pages still animate section-by-section. Otherwise reveal the
      // whole section.
      var inner = sec.querySelectorAll('section');
      if (inner.length >= 2) {
        for (var j = 0; j < inner.length; j++) {
          if (!heroish(inner[j])) tagEl(inner[j]);
        }
      } else if (!heroish(sec)) {
        tagEl(sec);
      }
    }
  }

  function revealAll() {
    document.querySelectorAll(SELECTOR).forEach(function(el) {
      el.classList.add('visible');
    });
  }

  function initReveal() {
    autoTag();
    var elements = Array.from(document.querySelectorAll(SELECTOR)).filter(function(el) {
      if (rebuilt(el)) { el.classList.add('visible'); return false; }
      return true;
    });
    if (!elements.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      revealAll();
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    // Observe every element and let the IntersectionObserver decide: it fires an
    // initial callback for elements already in view (reveal) and on-scroll for the
    // rest. This avoids the "in view at DOM-ready before images load" misfire that
    // pre-revealed deep elements (e.g. the buy box) so they never animated.
    elements.forEach(function(el) { observer.observe(el); });

    // TALL SECTION RESCUE, 2026-09-11.
    // intersectionRatio for an element taller than the viewport tops out at
    // viewportHeight / elementHeight. The blog index article list is 5,631px
    // tall on a roughly 720px phone screen, so its ratio can never exceed
    // 0.128 and the 0.15 threshold above is mathematically unreachable. The
    // observer never fired for it, so the list sat at opacity 0 until the
    // visitor scrolled or the 8 second un-stick timer below ran. Anyone
    // landing on /blogs/news saw a blank page under the header.
    //
    // Reveal only elements that are BOTH already in view AND too tall for the
    // threshold to ever be met. Everything else keeps its scroll animation
    // exactly as before, so nothing below the fold is pre-revealed.
    elements.forEach(function(el) {
      if (el.classList.contains('visible')) return;
      var r = el.getBoundingClientRect();
      var maxRatio = window.innerHeight / Math.max(r.height, 1);
      if (maxRatio < 0.2 && r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('visible');
        observer.unobserve(el);
      }
    });

    // Scroll backup so the reveal reliably plays as you scroll, no matter the
    // timing: reveal anything whose top has entered (or is above) the viewport.
    // Never reveals below-fold content early, so the animation always plays when
    // you reach it (this is what fixes deep elements like the buy box). rAF-throttled.
    var ticking = false;
    function sweep() {
      ticking = false;
      document.querySelectorAll(SELECTOR).forEach(function(el) {
        if (!el.classList.contains('visible') && el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add('visible');
        }
      });
    }
    window.addEventListener('scroll', function() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(sweep); }
    }, { passive: true });

    // Last-resort un-stick (short pages / total observer failure): reveal
    // everything after a generous window so nothing is ever permanently hidden.
    setTimeout(revealAll, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Theme editor / late DOM. initReveal runs once, at load, and its 8 second
  // un-stick timer has usually already fired by the time you add or edit a
  // section in the editor. Any section re-rendered after that point brings its
  // own markup-authored .optibio-reveal elements (the PDP authors 8 of them)
  // with nothing observing them, so they would sit at opacity 0 forever.
  // Observe just the reloaded section, with its own short un-stick timer.
  function __obRevealSectionLoad(evt) {
    var scope = evt && evt.target;
    if (!scope || !scope.querySelectorAll) return;
    var els = Array.prototype.slice.call(scope.querySelectorAll(SELECTOR));
    if (scope.matches && scope.matches(SELECTOR)) els.push(scope);
    els = els.filter(function(el) {
      if (rebuilt(el)) { el.classList.add('visible'); return false; }
      return !el.classList.contains('visible');
    });
    if (!els.length) return;

    function show() { els.forEach(function(el) { el.classList.add('visible'); }); }

    if (reducedMotion() || typeof IntersectionObserver === 'undefined') { show(); return; }

    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { obs.observe(el); });
    setTimeout(show, 3000);
  }
  document.addEventListener('shopify:section:load', __obRevealSectionLoad);
})();
/* Phase 32 fail safe: whatever the observer misses is shown 2.5 s after load. */
(function obRevealFailSafe(){function show(){document.querySelectorAll('.optibio-reveal:not(.visible), .cdr-reveal:not(.visible), .ob-reveal:not(.visible)').forEach(function(el){el.classList.add('visible');});}window.addEventListener('load',function(){setTimeout(show,2500);});setTimeout(show,6000);})();
